<template>
    <operate-content
        ref="operateContent"
        refer="createNewPage"
        mode="edit"
        :is-content-section-required="isContentSectionRequired"
        :outer-rules="rules"
    />
</template>

<script>
import emitter from 'utils/emitter';
import Rules from '@lsfe/rules';
import OperateContent from '../../OperateContent';
import { shared, operateInfoToken, createNewToken } from '../shareState';
import { getBaseModel } from '../baseModel';


const baseModel = getBaseModel();


const FORM_KEYS = ['subTitle', 'skuSellPointContentList', 'lbPicture', 'dlbPicture', 'video', 'mediumDescription', 'skuPictureList'];

const rules = {
    subTitle: [
        Rules.isRequired('副标题必填'),
        Rules.lenRange({ max: 44 }, '最多44个字'),
    ],
    skuSellPointContentList: [
        Rules.isRequired('商品卖点必填'),
        Rules.lenRange({ min: 2, max: 6 }, '大于2个小于6个'),
    ],
    lbPicture: [
        Rules.isRequired('列表用图必填'),
    ],
    skuPictureList: [
        Rules.isRequired('商品主图必填'),
        Rules.lenRange({ min: 1 }, '商品主图必填'),
    ],
};

export default {
    name: 'OperateContentManage',
    components: {
        OperateContent,
    },
    mixins: [emitter],
    data() {
        return {
            createInfoModel: {},
            isContentSectionRequired: false,
            rules: {},
        };
    },
    computed: {
        categoryId() {
            return this.createInfoModel.categoryId;
        },
    },
    async activated() {
        if (shared.stepChangeType === 'next') {
            try {
                await this.initState();
            } catch (error) {
                console.warn(error);
            } finally {
                this.dispatch(createNewToken, 'page-loaded', true);
            }
        }
    },
    created() {
        baseModel.registerVM(this, operateInfoToken);
    },
    methods: {
        async initState() {
            const draft = await this.fetchNewCreateData(baseModel.models.applyId);
            baseModel.setData(draft);

            const operateInfo = baseModel.initOperateInfo;
            this.createInfoModel = baseModel.models.applyInfoSection;
            this.$refs.operateContent._initForCreateNew({
                categoryId: this.createInfoModel.categoryId,
                bgCategoryId: this.createInfoModel.bgCategoryId,
                form: operateInfo,
            });
        },
        async fetchNewCreateData(applyId) {
            const draftData = await this.$service.fetchNewSellDetail({ applyId });
            return draftData;
        },
        getVMPostData() {
            return this.$refs.operateContent._getData();
        },
        async validate() {
            // 0不展示 1选填 2必填
            // const requiredKeys = Object.keys(REQUIRED_KEYS_MAP);
            const isContentSectionRequired = shared.categoryConfig.flowSpec && shared.categoryConfig.flowSpec.contentSectionRequired === 2;
            this.isContentSectionRequired = isContentSectionRequired;
            const formData = this.getVMPostData();
            if (isContentSectionRequired) {
                return this.$refs.operateContent.validate();
            } else {
                this.rules = { };
                this.$refs.operateContent.clearValidate();
                // 全部字段不填
                const keysEmpty = FORM_KEYS.every((key) => window._.isEmpty(formData[key]));
                if (keysEmpty) {
                    return true;
                } else {
                    this.rules = { ...rules };
                    return this.$nextTick().then(() => this.$refs.operateContent.validate());
                }
            }
        },
        // 临时处理，2次计算图片尺寸，保证width/height参数和实际图片尺寸一致
        picSizeRewrite(formData) {
            return this.$refs.operateContent.picSizeRewrite(formData);
        },
    },
};
</script>
